import { render, staticRenderFns } from "./appointmentDetails.vue?vue&type=template&id=09efa27e&scoped=true"
import script from "./appointmentDetails.vue?vue&type=script&lang=js"
export * from "./appointmentDetails.vue?vue&type=script&lang=js"
import style0 from "./appointmentDetails.vue?vue&type=style&index=0&id=09efa27e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09efa27e",
  null
  
)

export default component.exports